import { render, staticRenderFns } from "./Swift_code.vue?vue&type=template&id=018f8943&"
import script from "./Swift_code.vue?vue&type=script&lang=js&"
export * from "./Swift_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports